/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import {
  Row, Col, Modal, Collapse,
} from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CreateAccountHeader from '../CreateAccountHeader';
import { ReactComponent as Co3Logo } from '../../assets/co3-logo-dark-100.svg';
import CreateAccount from './CreateAccount';
import Login from './Login';
import { RedirectType } from '../../pages/Invite/redirectType.enum';

export const ModalWarning = Modal.warning;

const { Panel } = Collapse;

const CreateAccountOrLogin = ({
  companyId, companyName, regionFormConfig, userId, setStep, form, setUuid, redirectType,
}) => {
  const { t } = useTranslation();

  const resolveDefaultActiveKey = () => {
    switch (redirectType) {
      case RedirectType.GOOGLE:
        return '2';
      default:
        return undefined;
    }
  };

  return (
    <>
      <CreateAccountHeader
        company={companyName}
        descLabel={t(`FORM_USER_ACCOUNT.USER_ACCOUNT_DESC_${regionFormConfig.code}`)}
        regionFormConfig={regionFormConfig}
        detail
      />
      <Collapse
        accordion
        bordered={false}
        expandIconPosition="right"
        className="site-collapse-custom-collapse"
        expandIcon={({ isActive }) => (isActive ? <UpOutlined /> : <DownOutlined />)}
        defaultActiveKey={resolveDefaultActiveKey()}
      >
        <Panel
          header={(
            <Row>
              <Col>
                {t('FORM_USER_ACCOUNT.REGISTRATION_PANEL_HEADER')}
              </Col>
            </Row>
          )}
          key="1"
          className="site-collapse-custom-panel"
        >
          <CreateAccount
            form={form}
            regionFormConfig={regionFormConfig}
            companyId={companyId}
            companyName={companyName}
            userId={userId}
            setStep={setStep}
            setUuid={(e) => setUuid(e)}
          />
        </Panel>
        <Panel
          header={(
            <Row>
              <Col>
                {t('FORM_USER_ACCOUNT.LOGIN_PANEL_HEADER')}
              </Col>
              <Col style={{ height: '25px' }}>
                <Co3Logo style={{ width: '40px', height: '25px', marginLeft: '5px' }} />
              </Col>
            </Row>
          )}
          key="2"
          className="site-collapse-custom-panel"
        >
          <Login
            regionFormConfig={regionFormConfig}
            companyId={companyId}
            invitingCompany={companyName}
            redirectType={redirectType}
          />
        </Panel>
      </Collapse>
    </>
  );
};

export default CreateAccountOrLogin;

CreateAccountOrLogin.propTypes = {
  companyId: PropTypes.string.isRequired,
  companyName: PropTypes.string.isRequired,
  regionFormConfig: PropTypes.any.isRequired,
  userId: PropTypes.string.isRequired,
  setStep: PropTypes.func.isRequired,
  setUuid: PropTypes.func.isRequired,
  form: PropTypes.any.isRequired,
  redirectType: PropTypes.string.isRequired,
};
